import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import { normalizedData } from "@utils";
import Seo from "@components/seo";
import Layout from "@layout";
import Header from "@layout/header/layout-01";
import Footer from "@layout/footer/layout-01";
import PageHeader from "@containers/page-header/layout-02";
import CtaArea from "@containers/cta/layout-04";
import SectionTwo from "@containers/elements/google-map/section-02";
import { ctaData } from "@constants";
import { useTranslation } from "@hooks";

const GoogleMapPage = ({ pageContext, location, data }) => {
    const { t } = useTranslation();
    const content = normalizedData(data?.page?.content || []);
    const globalContent = normalizedData(data?.allGeneral.nodes || []);

    console.log(globalContent); // Check what data you have

    return (
        <Layout location={location}>
            <Seo title="Location" />
            <Header
                data={{
                    ...globalContent["header"],
                    ...globalContent["menu"],
                }}
            />
            <PageHeader
                pageContext={pageContext}
                location={location}
                title={t("Location")}
            />
            <main className="site-wrapper-reveal">
                <SectionTwo />
                <CtaArea data={ctaData} />
            </main>
            <Footer data={{ ...data.site.siteMetadata }} />
        </Layout>
    );
};

export const query = graphql`
    query GoogleMapPageQuery($locale: String!) {
        allGeneral(filter: { locale: { eq: $locale } }) {
            nodes {
                section
                ...HeaderOne
            }
        }
        site {
            ...Site
        }
        page(
            title: { eq: "faq" }
            pageType: { eq: "innerpage" }
            locale: { eq: $locale }
        ) {
            content {
                ...PageContent
            }
        }
    }
`;

GoogleMapPage.propTypes = {
    pageContext: PropTypes.shape({}),
    location: PropTypes.shape({}),
    data: PropTypes.shape({
        allGeneral: PropTypes.shape({
            nodes: PropTypes.arrayOf(PropTypes.shape({})),
        }),
        site: PropTypes.shape({
            siteMetadata: PropTypes.shape({
                contact: PropTypes.shape({}),
            }),
        }),
        page: PropTypes.shape({
            content: PropTypes.arrayOf(PropTypes.shape({})),
        }),
    }),
};

export default GoogleMapPage;
